export default __webpack_public_path__ + "static/media/welcome.84825831.png";